import React from "react";
import Content from "../Content";
import styled from "styled-components";
import PropTypes from "prop-types";
import TableOfContents from "../TableOfContents";
import PreviewCompatibleImage from "../PreviewCompatibleImage";
import Tags from "../Tags";
import AuthorBox from "../AuthorBox";
import { clearBg, color50, colorMain, mainBg, maxMobile } from "../../styles";
import Gallery from "./Gallery";

const TopSection = styled.div`
  background: ${clearBg};
  padding-top: 8px;
  overflow: hidden;
`;

const Title = styled.h1`
  color: ${colorMain};
  margin: 0 auto;
  font-style: normal;
  font-weight: 800;
  font-size: 60px;
  line-height: 133%;
  letter-spacing: -0.022em;
  text-align: center;
  max-width: 676px;

  @media (${maxMobile}) {
    font-size: 40px;
  }
`;

const SubTitle = styled(Title)`
  font-weight: normal;
  font-size: 42px;
  padding-top: 8px;
  padding-bottom: 32px;

  @media (${maxMobile}) {
    font-size: 28px;
  }
`;

const Display = styled.div`
  position: relative;

  &:before {
    position: absolute;
    content: "";
    top: 49%;
    background-color: ${mainBg};
    left: 50%;
    width: 100vw;
    height: 100%;
    transform: translateX(-50%);
  }
`;

const StickyWrapper = styled.div`
  position: relative;
`;

const Date = styled.div`
  margin: 64px 0 24px;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 133%;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: -0.014em;
  color: ${color50};
  width: 100%;

  @media (${maxMobile}) {
    font-size: 16px;
  }
`;

const BottomSection = styled.div`
  background-color: ${mainBg};
  padding-bottom: 56px;
`;

const Space = styled.span`
  display: block;
  height: 36px;
  pointer-events: none;
`;

export const PostWrapper = ({
  content,
  contentComponent,
  frontmatter,
  isPreview
}) => {
  const CurrentContent = contentComponent || Content;
  const { templateKey, title, subTitle, tags, featuredImage, gallery, date } = frontmatter;
  return (
    <>
      <TopSection className="top-section">
        <div className="container">
          <Title className="title">{title}</Title>
          {subTitle && (
            <SubTitle as="h2" className="subTitle">
              {subTitle}
            </SubTitle>
          )}

          {!subTitle && (
            <Space/>
          )}

          {featuredImage && ! templateKey && (
            <Display className="display">
              <PreviewCompatibleImage imageInfo={featuredImage} />
            </Display>
          )}
        </div>
      </TopSection>

      <BottomSection className="container botttom-section">
        <StickyWrapper data-sticky-container="true">
          {!isPreview && <TableOfContents title={title} />}
          <div className="post-content ">
            {gallery && !isPreview && (
              <>
                <Gallery gallery={gallery} />
              </>
            )}
            <CurrentContent content={content} />
          </div>
        </StickyWrapper>

        {!isPreview && <Date>~ {date} ~</Date>}

        {tags && tags.length ? <Tags tags={tags} /> : null}

        {!isPreview && <AuthorBox />}
      </BottomSection>
    </>
  );
};

PostWrapper.propTypes = {
  contentComponent: PropTypes.func
};

export default PostWrapper;
